import {Injectable} from '@angular/core';
import {ComponentStore} from '@ngrx/component-store';
import {PortfolioInvitation} from 'src/app/domain/model/portfolio/portfolio-invitation.model';

export interface JointHolderInvitationsToProcessState {
  invitations: PortfolioInvitation[] | undefined;
}

const emptyState = (): JointHolderInvitationsToProcessState => ({
  invitations: undefined,
});

@Injectable({
  providedIn: 'root',
})
export default class JointHolderInvitationsToProcessStore
  extends ComponentStore<JointHolderInvitationsToProcessState> {

  constructor() {
    super(emptyState());
  }

  public save(invitations: PortfolioInvitation[]): void {
    this.patchState(() => ({invitations}));
  }

  public sync(): PortfolioInvitation[] | undefined {
    return this.get().invitations;
  }

  public reset(): void {
    this.patchState(() => emptyState());
  }
}
